import { Box, Grid, Tab, Tabs } from "@mui/material";
import React from "react";

interface MuiTabsProps {
  tabDetails: TabsDetails[];
}
export interface TabsDetails {
  tabName: string;
  tabContent: React.ReactNode;
  index: number;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: "100%" }}
      role="tabpanel"
      hidden={value !== index}
      id={`horizontal-tabpanel-${index}`}
      aria-labelledby={`horizontal-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `horizontal-tab-${index}`,
    "aria-controls": `horizontal-tabpanel-${index}`,
  };
}

const MuiTabs = ({ tabDetails }: MuiTabsProps) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        mt: 0.5,
      }}
    >
      <Tabs
        TabIndicatorProps={{
          children: <span className="MuiTabs-indicatorSpan" />,
        }}
        orientation="horizontal"
        variant="fullWidth"
        value={value}
        onChange={handleChange}
        aria-label="mui tabs"
        sx={{
          borderBottom: 2,
          borderColor: "divider",
        }}
      >
        {tabDetails.map((tabDetail) => (
          <Tab
            label={tabDetail.tabName}
            {...a11yProps(tabDetail.index)}
            key={tabDetail.index}
            sx={{
              "&.Mui-selected": {
                margin: 0,
              },
            }}
          />
        ))}
      </Tabs>
       {tabDetails.map((tabDetail) => (
        <CustomTabPanel
          value={value}
          index={tabDetail.index}
          key={tabDetail.index}
        >
          {tabDetail.tabContent}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default MuiTabs;
